// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer-follow-us-section__wrapper .footer-follow-us-section__manage-cookies[data-v-5cfbc955]{position:absolute;left:0;margin-top:14px}@media (max-width:767px){.footer-follow-us-section__wrapper .footer-follow-us-section__manage-cookies[data-v-5cfbc955]{position:static}}.footer-follow-us-section__wrapper a[data-v-5cfbc955]{color:#fff}.footer-follow-us-section__wrapper a[data-v-5cfbc955]:hover{color:#a363ff}", ""]);
// Exports
module.exports = exports;
